<template>
  <section>
    <mf-tabs-menu v-model="tab" :tabs="tabs" class="mb-4" />

    <users-delete-data-requests-history-table v-show="tab === 0" ref="UsersDeleteDataRequestsHistoryTable" />
    <quit-club-requests-history-table v-show="tab === 1" ref="QuitClubRequestsHistoryTable" />
  </section>
</template>

<script>
import UsersDeleteDataRequestsHistoryTable from '@/modules/clientes/gerenciamento/views/components/UsersDeleteDataRequestsHistoryTable.vue'
import QuitClubRequestsHistoryTable from '@/modules/clientes/gerenciamento/views/components/QuitClubRequestsHistoryTable.vue'

export default {
  name: 'UsersDeleteDataRequestsHistory',
  components: {
    UsersDeleteDataRequestsHistoryTable,
    QuitClubRequestsHistoryTable,
  },
  data() {
    return {
      tab: 0,
    }
  },
  computed: {
    tabs() {
      return [
        {
          name: 'Histórico de solicitações',
          haveLength: false,
        },
        {
          name: 'Histórico de saídas do clube',
          haveLength: false,
        },
      ]
    },
  },
  methods: {
    updateUsersDeleteDataRequestsHistoryTable() {
      this.$refs.UsersDeleteDataRequestsHistoryTable.updateTable()
    },

    updateQuitClubRequestsHistoryTable() {
      this.$refs.QuitClubRequestsHistoryTable.updateTable()
    },
  },
}
</script>
